module.exports = __webpack_public_path__ + "static/media/qwantic-logo-blue.73e1c267.svg";